(() => {
    try {
        const dataWuModalTriggers = document.querySelectorAll('[data-wu-modal-v2-trigger]');
        const triggerElEventLisetener = (triggerEl,dataWuModalContents, isNotLoggedIn) => {
            triggerEl.addEventListener('click', (e) => {
                const homePageExperience = CookieService.getCookie('homePageExperience')
                if((homePageExperience === 'rodeo') && isNotLoggedIn) {
                    let href = e.target.getAttribute('href')
                    let dataScrollTop = e.target.getAttribute('data-scroll-top') === 'true';
                    if(dataScrollTop) window.scrollTo(0,0);
                    href && href !== '#' && sendMoneyLink && sendMoneyLink.setParam(href)
                    if (e.target.getAttribute('data-wu-modal-v2-trigger') === 'signUpModal') {
                        const signupLoadJsEvent = new CustomEvent('signupLoadJs');
                        document.dispatchEvent(signupLoadJsEvent);
                    }
                    e.preventDefault()
                    e.target.setAttribute('href','#')
                    if(!e.currentTarget.getAttribute('class').includes('signUpClose')){
                        dataWuModalContents.classList.toggle("d-flex");
                        dataWuModalContents.classList.toggle("d-none");
                    }                    
                }
            });
        }

        dataWuModalTriggers && dataWuModalTriggers.forEach((triggerEl) => {
            const triggerModalName = triggerEl.getAttribute('data-wu-modal-v2-trigger');
            const loggedInScenario = triggerEl.getAttribute('data-logged-in-scenario');
            const dataWuModalContents = document.querySelector(`[data-wu-modal-content=${triggerModalName}]`);
            if(triggerModalName && dataWuModalContents){
                if(loggedInScenario === 'true') {
                    const isLoggedIn = window.sessionStorage.getItem('AccountNumber')
                    triggerElEventLisetener(triggerEl,dataWuModalContents, !isLoggedIn)
                } else {
                    triggerElEventLisetener(triggerEl,dataWuModalContents, false)
                }
            }
        });
    } catch(e) {
        console.error('error in modal trigger : ', e);
    }
    
})()
